export * from './ItemIconMonotone';
export { default } from './ItemIconMonotone';
